import { ISearchFilter } from '../components/vacancies_filter/vacancies_filter';
import { IVacancy } from '../index';
import { IRegion } from '../types/region';
import { getRegionById } from '../utils';

export interface IVacancyFromResponse {
  company?: ICompany | null;
  /** Дата и время создания вакансии **/
  created?: string | null;
  /** Дата создания в "человечном" виде **/
  createdHumanized?: string | null;
  /** Описание вакансии **/
  description: string;
  /** Email контакта вакансии **/
  email?: string | null;
  /** Тип занятости **/
  employment: EEmployment;
  /** ID вакансии в базе данных **/
  id?: number | null;
  /** Осталось до обновления в "человечном" виде **/
  leftToUpdate?: string | null;
  /** Верхняя граница вилки зарплат **/
  maxSalary?: number | null;
  /** Нижняя граница требуемого опыта **/
  minExperience?: number | null;
  /** Нижняя граница вилки зарплат **/
  minSalary?: number | null;
  /** Телефонный номер контакта вакансии (без "+7") **/
  phone?: string | null;
  /** Название региона вакансии **/
  regionDisplayName?: string | null;
  /** ID региона вакансии **/
  regionId: number;
  /** Специализация вакансии **/
  specialization: string;
  /** Дата и время обновления вакансии **/
  updated?: string | null;
  /** Дата обновления в "человечном" виде **/
  updatedHumanized?: string | null;
  userId?: number | null;
}

export interface ICompany {
  isProfi?: boolean | undefined;
  /** "Человечное" время с момента регистрации на ЦИАН (напр. "7 лет 8 месяцев на ЦИАН") **/
  age?: string | null;
  /** Ссылка на аватарку компании **/
  avatarUrl?: string | null;
  /** ID компании **/
  id: number;
  /** Флаг, имеет ли компания статус "Работаем честно" **/
  isTrusted?: boolean | null;
  /** Название компании **/
  name?: string | null;
  /** Ссылка на страницу компании на сайте ЦИАН **/
  profileUrl?: string | null;
}

export enum EEmployment {
  /** Полная занятость **/
  Full = 'full',
  /** Частичная занятость **/
  Part = 'part',
  /** Сдельная оплата **/
  Piece = 'piece',
}

export function createVacancyFromResponse(v: IVacancyFromResponse, region: IRegion): IVacancy {
  const vacancy = {
    contactEmail: v.email || '',
    contactPhone: v.phone || '',
    description: v.description,
    employment: v.employment,
    id: v.id,
    leftToUpdate: v.leftToUpdate,
    maxSalary: v.maxSalary || undefined,
    minSalary: v.minSalary || undefined,
    region,
    specialization: v.specialization,
    updatedHumanized: v.updatedHumanized,
    userId: v.userId,
    workExperience: v.minExperience || undefined,
  } as IVacancy;

  if (v.company) {
    return Object.assign(vacancy, {
      company: {
        age: v.company.age,
        avatarUrl: v.company.avatarUrl,
        id: v.company.id,
        isProfi: v.company.isProfi,
        isTrusted: v.company.isTrusted,
        name: v.company.name,
        profileUrl: v.company.profileUrl,
      },
    } as IVacancy);
  }

  return vacancy;
}

export function createVacanciesFromResponse(
  vacanciesFromResponse: IVacancyFromResponse[],
  regions: IRegion[],
): IVacancy[] {
  return vacanciesFromResponse.map(value => {
    const region: IRegion = getRegionById(regions, value.regionId);
    if (!region) {
      throw new Error('Region not found');
    }

    return createVacancyFromResponse(value, region);
  });
}

export const formatRequestQueryString = (filter: ISearchFilter) => {
  const region = `regionId=${filter.region}`;
  const minSalary = filter.minSalary ? `&minSalary=${filter.minSalary}` : '';
  const maxSalary = filter.maxSalary ? `&maxSalary=${filter.maxSalary}` : '';
  const companyName = filter.companyName ? `&companyName=${encodeURIComponent(filter.companyName)}` : '';
  const p = filter.p ? `&p=${filter.p}` : '';

  return `${region}${minSalary}${maxSalary}${companyName}${p}`;
};
